import React from "react";

const AnimatedBackground = ({ variant = "waves" }) => {
  if (variant === "waves") {
    return (
      <>
        {/* Base gradient (your existing one) */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
            zIndex: 0,
          }}
        />

        {/* Animated Waves Layer */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            overflow: "hidden",
            zIndex: 0,
          }}
        >
          {/* Wave 1 - Pink/Purple */}
          <div
            style={{
              position: "absolute",
              width: "200%",
              height: "200%",
              top: "-50%",
              left: "-50%",
              background:
                "radial-gradient(circle, rgba(240,147,251,0.25) 0%, transparent 70%)",
              animation: "float1 15s ease-in-out infinite",
            }}
          />

          {/* Wave 2 - Deep Purple */}
          <div
            style={{
              position: "absolute",
              width: "180%",
              height: "180%",
              bottom: "-40%",
              right: "-40%",
              background:
                "radial-gradient(circle, rgba(118,75,162,0.15) 0%, transparent 70%)",
              animation: "float2 12s ease-in-out infinite",
            }}
          />

          {/* Wave 3 - Blue */}
          <div
            style={{
              position: "absolute",
              width: "150%",
              height: "150%",
              top: "20%",
              right: "-30%",
              background:
                "radial-gradient(circle, rgba(102,126,234,0.1) 0%, transparent 70%)",
              animation: "float3 18s ease-in-out infinite",
            }}
          />
        </div>

        {/* CSS Animations */}
        <style>{`
          @keyframes float1 {
            0%, 100% {
              transform: translate(0, 0) rotate(0deg);
              opacity: 1;
            }
            33% {
              transform: translate(30px, -30px) rotate(5deg);
              opacity: 0.8;
            }
            66% {
              transform: translate(-20px, 20px) rotate(-5deg);
              opacity: 0.9;
            }
          }

          @keyframes float2 {
            0%, 100% {
              transform: translate(0, 0) rotate(0deg);
              opacity: 1;
            }
            50% {
              transform: translate(-40px, 40px) rotate(10deg);
              opacity: 0.85;
            }
          }

          @keyframes float3 {
            0%, 100% {
              transform: translate(0, 0) scale(1);
              opacity: 1;
            }
            50% {
              transform: translate(20px, -20px) scale(1.1);
              opacity: 0.75;
            }
          }

          /* GPU Acceleration for smooth performance */
          @keyframes float1,
          @keyframes float2,
          @keyframes float3 {
            will-change: transform;
            transform: translateZ(0);
          }
        `}</style>
      </>
    );
  }

  // Future: Add more variants here (floating elements, etc.)
  return null;
};

export default AnimatedBackground;
